import { render } from "./DrugstoreMobile.vue?vue&type=template&id=1364c9ec&scoped=true&lang=pug"
import script from "./DrugstoreMobile.vue?vue&type=script&lang=js"
export * from "./DrugstoreMobile.vue?vue&type=script&lang=js"

import "./DrugstoreMobile.vue?vue&type=style&index=0&id=1364c9ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1364c9ec"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QItem from 'quasar/src/components/item/QItem.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QSpinnerDots,QBtn,QIcon,QImg,QExpansionItem,QScrollArea,QItem});qInstall(script, 'directives', {ClosePopup});
